import React from 'react';
import ReactDOM from 'react-dom';
import './app/utils/logger';
import './app/utils/local-storage';
import Main from './app/Main';
import registerServiceWorker from './registerServiceWorker';
import './i18n';

// @ts-ignore
ReactDOM.render(<Main />, document.getElementById('root'));
// Register service worker
if (process.env.NODE_ENV === 'production') {
  registerServiceWorker();
} else if (
  process.env.REACT_APP_LOAD_FROM_CACHE === 'true'
  && process.env.NODE_ENV === 'development'
  && 'serviceWorker' in navigator
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/dev-service-worker.js', { updateViaCache: 'none' });
  });
}
